import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { onUsers } from "../../redux/homeAction";
import "./User.css";
import CustomPagination from "../CustomPagination";

const UsersTable = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0); // start at 1 for our pagination component
  const [limit] = useState(5);
  const [loading, setLoading] = useState(false);

  const getOnUsers = useSelector((state) => state.home.getOnUsers);

  useEffect(() => {
    setLoading(true);
    dispatch(onUsers(setLoading, page, limit));
  }, [page, dispatch]);

  const handleViewProfile = (user) => {
    alert(`View profile of ${user.name}`);
  };

  const handleBlockUser = (user) => {
    alert(`Block user ${user.name}`);
  };

  // Calculate total pages
  const totalPages = Math.ceil((getOnUsers?.totalUsers || 0) / limit);

  return (
    <div className="mt-5">
      <h2 className="mb-4 text-center">Users List</h2>

      {loading ? (
        <p className="text-center">Loading...</p>
      ) : (
        <>
          <div className="table-responsive shadow-sm rounded">
            <h5>Total Users - {getOnUsers?.totalUsers || 0}</h5>
            <table className="table table-hover table-striped table-bordered align-middle">
              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {getOnUsers?.users?.map((user, index) => (
                  <tr key={user._id}>
                    <td>{page * limit + index + 1}</td>
                    <td>{user.name}</td>
                    <td>{user.phone}</td>
                    <td>{user.email}</td>
                    <td>{user.role}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => handleViewProfile(user)}
                      >
                        View
                      </button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleBlockUser(user)}
                      >
                        Block
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <CustomPagination
              currentPage={page}
              totalPages={totalPages}
              onPageChange={(page) => setPage(page)}
            />
          )}
        </>
      )}
    </div>
  );
};

export default UsersTable;
